import React from 'react'
import { useNavigate } from 'react-router-dom'

const IntroducePage = (props:any) => {
    const navigate = useNavigate()

    const goToLogin = () => {
        navigate('/login', {replace:true})
    }

    return (
        <div>
            <h1>IntroducePage - 임시 페이지</h1>
            <button style={{width:'100px', height:'24px', padding:'6px 3px',
                fontSize:'12px', borderRadius:'5px', background:'#51D7DF', color:'#FFFFFF', cursor:"pointer", margin:' 0 5px'}} onClick={goToLogin}>로그인페이지로</button>
        </div>
    )
}

export default IntroducePage
